import React, { useEffect, useState } from "react";
import { TableContainer, Table } from "@mui/material";

import { useDeleteLaborData, useGetLaborDataByRouteId } from "../../hooks";
import { useEmployeeScanContext } from "../../hooks/contexts/EmployeeScanContextProvider";
import { WarningDeleteDialog } from "../../dialogs";

import LaborTableHeader from "./LaborTableHeader";
import LaborTableBody from "./LaborTableBody";

export const LaborTable = ({ routeId, enabled = true }) => {
  const { mutate: deleteLaborData, isSuccess } = useDeleteLaborData();
  const { data: laborData } = useGetLaborDataByRouteId(enabled && routeId);

  // Get scan context
  const { scannedEmployee, canEditLabor } = useEmployeeScanContext();
  const showHeatCode = laborData?.some((labor) => labor?.heatCode);
  const showContextMenuColumn =
    laborData?.some((labor) => canEditLabor?.(labor?.userId)) ?? false;

  useEffect(() => {
    isSuccess && window.location.reload();
  }, [isSuccess]);

  const [deletingId, setDeletingId] = useState(false);
  const handleDeleteClose = () => setDeletingId(false);
  const handleDeleteSubmit = () => {
    if (deletingId) {
      deleteLaborData(deletingId);
      handleDeleteClose();
    }
  };

  return (
    <TableContainer sx={{ backgroundColor: "hubColors.white" }}>
      <Table id="CustomerOrdersTable">
        <LaborTableHeader
          showHeatCode={showHeatCode}
          showContextMenuColumn={showContextMenuColumn}
        />
        <LaborTableBody
          routeId={routeId}
          enabled={enabled}
          setDeletingId={setDeletingId}
          showHeatCode={showHeatCode}
          showContextMenuColumn={showContextMenuColumn}
          scannedEmployee={scannedEmployee}
          canEditLabor={canEditLabor}
        />
      </Table>
      <WarningDeleteDialog
        isOpen={!!deletingId}
        onClose={handleDeleteClose}
        onSubmit={handleDeleteSubmit}
        title="You are about to delete a labor ticket!"
      />
    </TableContainer>
  );
};

export default LaborTable;
